import React from 'react';
import Slider from "react-slick";
import styles from '../styles/layouts/partners.module.css';
import fundoReuniao from '../assets/fundo_reuniao.jpeg';
import parceiro1 from '../assets/dcomp_ufsj.png';
import parceiro2 from '../assets/brasiljunior.png';
import parceiro3 from '../assets/FEJEMG-Branca.png';
import parceiro4 from '../assets/Nucleovertentes.png';

const Partners = () => {
  const images = [
    parceiro1, parceiro2, parceiro3, parceiro4
  ];

  const settings = {
    dots: false, // Habilita os indicadores (dots)
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false, // Ativa o autoplay
    // autoplaySpeed: 3000,
    speed: 5500,
    cssEase: "linear",
    arrows: false, // Desativa as setas de navegação
  };

  return (
    <section className={styles.stats_section} style={{ backgroundImage: `url(${fundoReuniao})` }}>
      <div className={styles.overlay}></div>
      <div className={styles.stats_container}>
        <div className={styles.item}>
          <h1>Parceiros</h1>
          <hr className={styles.title_underline} />
          <p>Confira alguns dos nossos parceiros</p>
        </div>
        <div className={styles.slider_container}>
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index} className={styles.slide}>
                <img src={img} alt={`parceiro ${index + 1}`} className={styles.partner_image} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Partners;
